// extracted by mini-css-extract-plugin
export default {"labelItem":"LabeledItem_labelItem__DPX6U","text":"LabeledItem_text__eBEXm","description":"LabeledItem_description__Q0j25"};